export default __webpack_public_path__ + "static/header-marketing-06ff7d5dabf2284531e7e7c530e76707.png";